export enum Color {
  Black = 'black',
  Blue = 'blue',
  AzureBlue = 'azure-blue',
  LightBlue = 'light-blue',
  JokerBlue = 'joker-blue',
  Green = 'green',
  MutedGreen = 'muted-green',
  Orange = 'orange',
  Violet = 'violet',
  DarkViolet = 'dark-violet',
  DarkPink = 'dark-pink',
  WarmGrey = 'warm-grey',
  OliveGreen = 'olive-green',
  Turquoise = 'turquoise',
  Yellow = 'yellow',
  Pink = 'pink',
  Brown = 'brown',
  Red = 'red',
  MiddleRed = 'middle-red',
  Grey = 'grey',
  MiddleGrey = 'middle-grey'
}
